export default {
  3: "SUSPENDED",
  7: "PREMIUM_FREE",
  14: "EXHALED",
  99: "IN_PROLONGATION",
  996: "REJECTED",
  997: "ENDING",
  998: "EXPIRING",
  999: "EXPIRED",
};
